<template>
  <div
    class="item"
    :id="`product_${item.id}`"
    :class="{
      noImg: !item.thumb && !setDefaultImage,
      pause: item.disabled || outOfStock,
    }"
    @click.stop="itemClick($event, item)">
    <div class="boxInner">
      <div v-if="item.info.promotion" :style="customStkr" class="stkr">
        <img :src="promotionLabel(item.info)" alt="" />
      </div>
      <div v-if="item.thumb !== '' || setDefaultImage" class="thumb"> 
        <div v-if="item.thumb"
          :style="{backgroundImage: `url('${item.thumb}')`}"
          :data-ratio="item.thumbRatio"
          alt=""
          class="thumbImg"></div>
        <img v-else-if="setDefaultImage" src="@/assets/img/img_product_default.png" alt="" class="defaultImg">
        <span v-if="itemDetail.desc || itemDetail.detail" class="btnDetail notranslate" @click.prevent="detailClick($event)">{{locale.product_item_details}}</span>
        <p v-if="responsive === 'tablet' && outOfStock" class="outOfStock notranslate">
          {{ locale.out_of_stock }}
        </p>
        <p v-else-if="responsive === 'tablet' && item.disabled" class="outOfStock notranslate">
          {{ locale.amenity_pause }}
        </p>
        <p v-else-if="responsive === 'tablet' && !isAvailable" class="outOfStock notranslate">
          {{ locale.not_available }}
        </p>
        <!-- 페이지 링크가 아닌 경우 링크버튼 생성 -->
        <SetLink
          v-if="
            linkInfo.href &&
            linkInfo.href !== '#' &&
            item.link &&
            !(item.link.type === 'page' && item.link.pageId)
          "
          class="linkBtn"
          :lang="lang"
          :linkTarget="item.link" />
        <!-- //페이지 링크가 아닌 경우 링크버튼 생성 -->
      </div>
      <!-- 이용시간, 처리시간 -->
      <div
        class="availableBox notranslate"
        :class="{ break: item.timeTaken && item.timeTaken >= 6 }"
        :data-state="isAvailable ? '01' : '02'">
        <p class="message" @click="onTableOpen">
          <i></i> {{ availableMessage }}
        </p>
        <div v-if="timeTaken" class="timeTaken">{{ timeTaken }}</div>
      </div>
      <!-- <div v-if="!isAvailable" @click="onTableOpen" class="availableTable">
        <p>{{ locale.available_time }}</p>
      </div> -->
      <!-- //이용시간, 처리시간 -->
      <div class="infoBox">
        <div class="info">
          <div class="desc colorGrey">{{ item.info.desc[lang] }}</div>
          <div class="name">{{ item.info.name[lang] }}</div>
          <div class="detail colorGrey">{{ item.info.detail[lang] }}</div>
        </div>
        <div class="order">
          <div
            class="price"
            :class="{ guestType: guestTypePrice && isGuestDiscount }">
            <div
              v-if="(guestTypePrice && isGuestDiscount) || isDutyFree"
              class="guestTypeName mb5">
              <span v-if="isGuestDiscount">
                {{ guestTypePrice.name[lang] }}
                <i class="notranslate">({{ guestTypePrice.priceDiscount }})</i>
              </span>
              <span v-if="isDutyFree">Duty Free</span>
            </div>
            <!-- 가격표시 추가 div -->
            <div class="price-text-display">
              <span v-if="isSale" class="sale colorGrey notranslate">
                {{ priceFormat(item.info.salePrice) }}
              </span>
              <span class="oPrice notranslate">
                {{ !(guestTypePrice && isGuestDiscount) && isDutyFree ? priceFormat(priceDutyFree(item.info.price)) : priceFormat(item.info.price) }}
              </span>
              <!-- 고객식별타입 -->
              <span
                v-if="guestTypePrice && isGuestDiscount"
                class="guestPrice notranslate">
                {{ priceFormat(guestTypePrice.price) }}
              </span>
              <!-- //고객식별타입 -->
            </div>
          </div>
          <p v-if="responsive !== 'tablet' && outOfStock" class="outOfStock notranslate">
            {{ locale.out_of_stock }}
          </p>
          <p v-else-if="responsive !== 'tablet' && item.disabled" class="outOfStock notranslate">
            {{ locale.amenity_pause }}
          </p>
          <p v-else-if="responsive !== 'tablet' && !isAvailable" class="outOfStock notranslate">
            {{ locale.not_available }}
          </p>
          <div v-else class="request notranslate">
            <!-- 페이지 링크 없으면 장바구니 버튼 -->
            <div class="quantity">
              <select
                v-model="quantity"
                :disabled="
                  item.disabled || !isAuth || !isAvailable || isPageLink
                "
                class="input"
              >
                <option v-for="count in total" :key="count" :value="count">
                  {{ count }}
                </option>
              </select>
            </div>
            <!-- 페이지 링크인 경우 페이지 레이어에서 주문 (옵션 등 추가가능) -->
            <button
              v-if="isPageLink"
              type="button"
              class="btnCart btnDetails"
              :style="
                !(item.disabled || !isAuth || !isAvailable) && {
                  ...skinStyle('productBtncart', 'background-color'),
                  ...skinStyle('productBtncart', 'border-color'),
                }
              "
              :disabled="item.disabled || !isAuth || !isAvailable"
              @click="setDetail({ detail: item.id, page: item.link.pageId })"
            >
              <span class="blind">{{ locale.do_order }}</span>
            </button>
            <button
              v-else
              type="button"
              class="btnCart"
              :style="
                !(item.disabled || !isAuth || !isAvailable) && {
                  ...skinStyle('productBtncart', 'background-color'),
                  ...skinStyle('productBtncart', 'border-color'),
                }
              "
              :disabled="item.disabled || !isAuth || !isAvailable"
              @click="addCart"
            >
              <span class="blind">add to cart</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <AvailableTable
      v-if="availableTable"
      :table="item.available.set"
      :locale="locale"
      @close="onTableClose" />
    <Detail
      v-if="viewDetail"
      :item="item"
      :lang="lang"
      :locale="locale"
      :responsive="responsive"
      :setDefaultImage="setDefaultImage"
      @close="viewDetail = false"
      @addCart="addCart" />
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import SetLink from '@/components/Util/SetLink'
import AvailableTable from '@/components/Util/AvailableTable'
import Detail from '@/components/Product/DetailLayer'
import { mapGetters } from 'vuex'

export default {
  name: 'ProductItem',
  props: [
    'lang',
    'responsive',
    'locale',
    'isAuth',
    'roomKey',
    'item',
    'manageList',
    'place',
    'viewCart',
    'setDefaultImage'
  ],
  components: {
    SetLink,
    AvailableTable,
    Detail
  },
  computed: {
    ...mapGetters({
      getGuestTypePrice: 'util/getGuestTypePrice',
      getTax: 'payment/getTax',
      pointColors: 'common/getPointColors',
      getAvailableDay: 'util/getAvailableDay',
      getSetting: 'product/getProductSetting'
    }),
    promotionList () {
      const promotion = this.getSetting && this.getSetting.promotion
      return promotion
    },
    tax () {
      return this.$store.state.payment.tax
    },
    siteInfo () {
      return this.$store.state.siteInfo
    },
    siteCommon () {
      return this.$store.getters['common/getSetting']
    },
    linkInfo () {
      // 유효한 링크값이 있는지 검사
      const setLink = this.$store.getters['util/setLink']
      const info = setLink(this.item.link)
      return info
    },
    isPageLink () {
      return this.item.link && this.item.link.type === 'page' && this.item.link.pageId
    },
    customStkr () {
      const info = this.item.info
      return info && info.promotionCustom && {
        width: `${info.promotionSize}px`,
        height: 'auto',
        maxWidth: '120px',
        maxHeight: '120px'
      }
    },
    isSale () {
      const salePrice = Number(this.item.info.salePrice)
      const price = this.price
      return salePrice && (salePrice > price)
    },
    price () {
      return Number(this.item.info.price)
    },
    // 재고
    qty () {
      const pId = this.item.info.pId
      const manage = this.manageList && this.manageList.find(x => (x.pid === pId) || null)
      return this.item.manage && manage ? manage.qty : null
    },
    min () {
      return this.item.info.min <= 1 ? 1 : this.item.info.min
    },
    max () {
      const max = this.item.info.max
      const qty = this.item.manage ? this.qty || max : max
      return max > qty ? qty : max
    },
    total () {
      const diff = Number(this.max) - Number(this.min)
      return diff >= 1 ? diff + 1 : 1
    },
    outOfStock () {
      return this.item.manage && this.qty !== null && this.qty <= 0
    },
    guestTypePrice () {
      const info = this.item.guestType
      const getGuestTypePrice = info ? this.getGuestTypePrice(info, this.price) : null
      return info && info.active && info.discount
        ? {
          id: info.id,
          name: info.name,
          ...getGuestTypePrice
        }
        : null
    },
    isGuestDiscount () {
      return (this.item.guestType && this.item.guestType.active && this.item.guestType.discount) &&
        ((this.item.guestType.percent.active && this.item.guestType.percent.value !== 0) ||
        (this.item.guestType.price.active && this.item.guestType.price.value !== 0))
    },
    timeTaken () {
      const timeTaken = this.item.timeTaken
      const message = timeTaken && timeTaken !== ''
        ? timeTaken < 6
          ? `${timeTaken * 10}${this.locale.minute}`
          : this.locale.hour_more
        : null
      return message
    },
    itemDetail () {
      const lang = this.lang
      const desc = this.item.info.desc[lang]
      const detail = this.item.info.detail[lang]
      function itemContent (str) {
        return regExp.replaceAllEmpty(str).length > 0
          ? str
          : null
      }
      return {
        desc: itemContent(desc),
        detail: itemContent(detail)
      }
    },
    isDutyFree () {
      return this.$store.getters['guest/isDutyfreeGuest']
    }
  },
  watch: {
    viewCart (isView) {
      if (isView) {
        this.viewDetail = false
      }
    }
  },
  mounted () {
    this.quantity = this.min
    this.checkAvailableTime()
  },
  data () {
    return {
      quantity: 1,
      summaryData: null,
      availableTable: false,
      isAvailable: true,
      availableMessage: '',
      checkAvailable: 0,
      viewDetail: false
    }
  },
  methods: {
    checkAvailableTime () {
      const item = this.item
      function timeMessage (arr) {
        arr = arr.map(x => {
          return `${x.from} ~ ${x.to}`
        })
        return arr.join(' / ')
      }
      this.checkAvailable = setInterval(() => {
        const available = item.available // submit 데이터
        const isAlways = available.state === '01' // 01 ? always : each
        const today = moment().isoWeekday() - 1
        const day = available.set[today]
        const check = this.getAvailableDay(day)
        const isAvailable = isAlways
          ? true
          : check
        this.isAvailable = isAvailable
        this.availableMessage = isAlways
          ? timeMessage([{ from: '00:00', to: '24:00' }])
          : timeMessage(day.time)
      }, 1000)
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    promotionLabel (info) {
      const promotionList = this.promotionList
      const promotionIcon = promotionList && info.promotion && promotionList.find(x => x.id === info.promotion)
      const isDefault = info && !info.promotionCustom 
      const src = isDefault
        ? require(`@/assets/img/product_stkr_${info.promotion}.png`)
        : promotionIcon ? promotionIcon.icon : ''
      return src
    },
    hasText (str) {
      return regExp.replaceAllEmpty(str).length
    },
    priceFormat (price) {
      const code = this.siteCommon.currency.toUpperCase()
      return regExp.priceFormat(price, code)
    },
    priceDutyFree (price) {
      return regExp.priceDutyFree(price)
    },
    onTableOpen (e) {
      e.stopPropagation()
      if (this.item.available.state === '02') {
        this.availableTable = true
      }
    },
    onTableClose (e) {
      this.availableTable = false
    },
    setDetail (data) {
      this.$store.commit('product/setProductAvailableTime', this.item.available)
      this.$emit('setDetail', data)
    },
    itemClick (e, item) {
      if (this.responsive === 'tablet') { // 장바구니에 담을 수 없는 케이스 item.disabled || !isAuth || !isAvailable
        if (this.item.disabled) {
          this.$emit('setToastMessage', this.locale.state_unavailable)
        } else if (!this.isAuth) {
          this.$emit('setToastMessage', this.locale.alert_permission)
        } else if (!this.isAvailable) {
          this.$emit('setToastMessage', this.locale.state_unavailable)
        } else if (this.isPageLink) { // 페이지 연결된 상품?
          this.setDetail({ detail: item.id, page: item.link.pageId })
        } else if (this.itemDetail.desc || this.itemDetail.detail) { // 상세설명 있는 상품?
          this.viewDetail = true
        } else {
          this.addCart()
        }
      } else { // 모바일에서
        if (this.isPageLink) { // 페지연결
          this.setDetail({ detail: item.id, page: item.link.pageId })
        } else {
          e.preventDefault()
        }
      }
    },
    detailClick (e) {
      e.stopPropagation()
      this.viewDetail = true
    },
    setPageDetail () {
      const item = this.item
      this.setDetail({ detail: item.id, page: item.link.pageId })
    },
    async addCart () {
      if (this.isPageLink && this.viewDetail) {
        this.setPageDetail()
        this.viewDetail = false
      } else {
        this.$store.commit('loading', true)
        const submitAt = moment().toISOString()
        const submitTo = this.item.submitTo
        const submitLabel = this.$store.state.submit.submitCode && this.$store.state.submit.submitCode.find(x => x.id === submitTo)
        const ota = await this.$store.dispatch('authentication/getOtaKey')
        const itemPrice = this.isDutyFree ? this.priceDutyFree(this.price) : this.price
        const priceInfo = {
          currency: this.siteCommon.currency.toUpperCase(),
          price: itemPrice,
          quantity: this.quantity,
          sum: 0,
          total: itemPrice * this.quantity,
          ...this.tax && {
            subtotal: this.price * this.quantity,
            tax: this.getTax(this.price * this.quantity),
            taxLabel: `${this.tax}%`,
            total: this.price * this.quantity + this.getTax(this.price * this.quantity)
          }
        }
        const productInfo = {
          available: this.item.available,
          subject: this.item.info.name,
          thumbnail: this.item.thumb || ''
        }
        const summaryData = {
          submitAt: submitAt,
          name: this.item.info.name,
          price: itemPrice,
          quantity: this.quantity,
          thumb: this.item.thumb,
          ...this.tax && {
            subtotal: this.price * this.quantity,
            tax: this.getTax(this.price * this.quantity),
            taxLabel: `${this.tax}%`,
            total: this.price * this.quantity + this.getTax(this.price * this.quantity)
          }
        }
        const guestTypePrice = this.guestTypePrice || null
        const cartData = {
          title: this.item.info.pName,
          pId: this.item.info.pId || null,
          pageId: null,
          productId: this.$route.params.productId,
          productItemId: this.item.id,
          submitAt: submitAt,
          submitId: this.item.submitTo,
          cartOta: ota,
          ...this.item.submitCategory && {
            submitCategory: this.item.submitCategory
          },
          ...this.place && {
            place: this.place
          },
          categoryLabel: submitLabel,
          content: [
            {
              type: 'quantity',
              label: this.locale.quantity,
              value: priceInfo
            }
          ],
          price: {
            info: priceInfo,
            option: null
          },
          info: productInfo,
          manage: this.item.manage,
          pickup: this.item.pickup,
          ...this.item.pickup === 'auto' && {
            pickupTime: this.item.pickupTime
          },
          ...guestTypePrice && {
            guestTypePrice: {
              ...guestTypePrice,
              quantity: this.quantity,
              total: this.guestTypePrice.price * this.quantity
            }
          },
          ...this.item.info.pIdType && {
            pIdType: this.item.info.pIdType
          }
        }
        this.$store.commit('loading', false)
        this.$emit('addCart', {
          summaryData: summaryData,
          cartData: cartData
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.thumb >p{
  display: none;
}
</style>